document.addEventListener('DOMContentLoaded', function() {
  const isMobile = window.matchMedia('(max-width: 1279px)').matches;
  
  if (isMobile) {
    const tooltips = document.querySelectorAll('.tooltip');
    
    tooltips.forEach(tooltip => {
      const trigger = tooltip.querySelector('.tooltip-trigger');
      
      if (trigger) {
        // Toggle tooltip on click
        trigger.addEventListener('click', function(e) {
          e.stopPropagation();
          
          // Close other tooltips
          tooltips.forEach(other => {
            if (other !== tooltip) {
              other.classList.remove('active');
            }
          });
          
          // Toggle current tooltip
          tooltip.classList.toggle('active');
        });
      }
    });
    
    // Close tooltip when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.tooltip')) {
        tooltips.forEach(tooltip => {
          tooltip.classList.remove('active');
        });
      }
    });
  }
});

